/**
 * What a manager may do on the dashboard, served by
 * `GET /api/managers/me/configurations` — the manager twin of
 * `/curators/me/configurations`, so each manager can be set up as a full
 * manager or a view-only one.
 */
export const MANAGER_ENTITLEMENTS = {
  /** Download tracks and playlist mixes. */
  AUDIO_DOWNLOADS: "audio-downloads",
  /** The read-only "All Messages" view of every curator conversation. */
  ADMIN_MESSAGES: "admin-messages",
} as const;

export type ManagerEntitlement =
  (typeof MANAGER_ENTITLEMENTS)[keyof typeof MANAGER_ENTITLEMENTS];

/** Same shape as the curator configuration: the keys that are on. */
export type IManagerConfiguration = {
  entitlements: string[];
};
